import React, { useState, useRef, useEffect } from "react";
import "./VideoCarousel.css";

const slides = [
  { type: "video", src: "/network-globe.mp4", title: "Network Globe" },
  { type: "video", src: "/keyboard-typing.mp4", title: "Keyboard Typing" },
  { type: "video", src: "/windmill-clouds.mp4", title: "Windmill Clouds" },
  // { type: "image", src: "/corporate-building.jpg", title: "Corporate Building" }, commenting these images for better viewing experience
  // { type: "image", src: "/night-city.jpg", title: "Night City" },
];

const VideoCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);
  const timeoutRef = useRef(null);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  // Automatically advance for image or video
  useEffect(() => {
    const currentSlide = slides[currentIndex];

    if (currentSlide.type === "image") {
      timeoutRef.current = setTimeout(goToNext, 4000); // 4 sec for image
    }

    return () => clearTimeout(timeoutRef.current);
  }, [currentIndex]);

  useEffect(() => {
  const currentSlide = slides[currentIndex];
  const videoNode = videoRef.current;

  if (currentSlide.type === "video" && videoNode) {
    videoNode.load();
    videoNode
      .play()
      .catch(() => {
        // autoplay might be blocked
      });

    const handleEnded = () => goToNext();
    videoNode.addEventListener("ended", handleEnded);

    return () => {
      if (videoNode) {
        videoNode.removeEventListener("ended", handleEnded);
      }
    };
  }
}, [currentIndex]);

  // const goToSlide = (index) => {
  //   setCurrentIndex(index);
  // };

  const currentSlide = slides[currentIndex];

  return (
    <div className="video-carousel-container">
      {currentSlide.type === "video" ? (
        <video
          ref={videoRef}
          src={currentSlide.src}
          className="video-element"
          muted
          autoPlay
          playsInline
          preload="auto"
        />
      ) : (
        <img
          src={currentSlide.src}
          alt={currentSlide.title}
          className="video-element"
        />
      )}
      {/* DONOT remove below division we may need it in future
      <div className="carousel-controls">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`carousel-dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(idx)}
            aria-label={`Go to ${slides[idx].title}`}
          />
        ))}
      </div> */}
    </div>
  );
};

export default VideoCarousel;
